var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen",attrs:{"id":"advertiserContainer"}},[_c('div',{staticClass:"advertiser__container full-screen"},[_c('SideMenu'),_c('router-view')],1),_c('footer-view',{staticStyle:{"border-top":"1px solid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }